<template>
  <div class="occlude">
    <div>
      <div class="occlude-content">
        在友圈查看更多動態消息
      </div>
      <div class="btn-group">
        <div @click="openLoginWindows" class="btn-login">登入</div>
        <span>或</span>
        <div @click="openRegisterWindows" class="btn-register">立即加入</div>
      </div>
      <a href="https://www.lale.im/laleapp_privacy_policy.html">服務條款與隱私權條款</a>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'Occlude',
  mounted() {},
  computed: {},
  methods: {
    ...mapMutations(['SET_OPEN_WINDOW_STATUS', 'SET_OPEN_REGISTER_STATUS', 'SET_SHOW_MODAL', 'SET_OPEN_WINDOW_STATUS']),
    // 登入元件開啟
    // openLoginWindows() {
    //   this.SET_OPEN_WINDOW_STATUS(true);
    // },
    // 開啟註冊選單
    // openRegisterWindows() {
    //   this.SET_OPEN_REGISTER_STATUS(true);
    // }
    openRegisterWindows() {
      this.SET_SHOW_MODAL({ isShow: true, modalName: 'Register' });
      this.SET_OPEN_WINDOW_STATUS(true);
    },

    openLoginWindows() {
      this.SET_SHOW_MODAL({ isShow: true, modalName: 'login' });
      this.SET_OPEN_WINDOW_STATUS(true);
    }
  }
};
</script>

<style scoped lang="scss">
a{
text-decoration:none;
color:#ADADAD;
}
.btn-group {
  display: flex;
  align-items: baseline;
  span {
    margin: 30px 36px;
  }
}

.occlude-content {
  text-align: center;
}

.btn-login {
  padding: 5px 63px;
  color: #fff !important;
  background-color: #f08f00;
  border: 1px solid #f08f00;
  border-radius: 50px;
  cursor: pointer;
  text-align: center;
}

.btn-register {
  padding: 5px 49px;
  color: #fff !important;
  background-color: #24bab9;
  border: 1px solid #24bab9;
  border-radius: 50px;
  cursor: pointer;
}
.occlude {
  position: absolute;
  z-index: 9;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 20px 70px 30px 70px;
  font-family: Noto Sans TC;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .btn-group {
    span {
      margin: 15px;
    }
  }
  .btn-login,
  .btn-register {
    padding: 4px 16px;
    min-width: 120px;
    text-align: center;
  }
}
</style>
